import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import australia from "../assets/kangaroo/img1.png";
import img1 from "../assets/kangaroo/Education.png";
import img2 from "../assets/kangaroo/QEAC.png" 
import img3 from "../assets/kangaroo/britishcouncil.png"
import img4 from "../assets/kangaroo/ITAC.png"
import img5 from "../assets/kangaroo/USATC.png"
import img6 from "../assets/kangaroo/Canada Course.png"
import img7 from "../assets/kangaroo/NZEAC.png"
import img8 from "../assets/kangaroo/IELTS.png"
import img9 from "../assets/kangaroo/BUPA.png"
import img10 from "../assets/kangaroo/BUPA1.png"
import img11 from "../assets/kangaroo/NIB.png"
import img12 from "../assets/kangaroo/Australian.png"
import img13 from "../assets/kangaroo/medibank.png"
import img14 from "../assets/kangaroo/b_logo.png"
import PartnerService from '../services/PartnerService';
import { useQuery } from '@tanstack/react-query';
import { imageBaseApi } from '../services/imageBaseApi';

const Professional = ({about=true, aboutPartner=false}) => {
   const ProfImage = [
  { src: img1, alt: "Education Certification" },
  { src: img2, alt: "QEAC" },
  { src: img3, alt: "British Council" },
  { src: img4, alt: "ITAC" },
  { src: img5, alt: "USATC" },
  { src: img6, alt: "Canada Course" },
  { src: img7, alt: "NZEAC" },
];

const IeltsImg = [
  {src:img14,alt:"british"},
  { src: img8, alt: "IELTS" },
 
]

const InsImg =[
  {src:img9,alt:"Bupa"},
  {src:img11,alt:"NIB"},
  {src:img12,alt:"Australian"},
  {src:img13,alt:"medibank"},
]
const borderColor = '#dee2e6';

const fetchData= async ()=>{
  const response = await PartnerService.getList();
  return response;
}

const {isPending,error, data: partnerData} = useQuery({
  queryKey: ['partnerData'],
  queryFn: fetchData,
})


  return (
    <div className='main-container' style={{marginBottom:"156px"}}>
      <Container fluid className=''>

      
      {about&&(  <Row className='justify-content-start'>
          <Col xs={12} lg={10} className='text-start p-0'>
            <h1 className="font-level-4 mb-3 lh-1 vw-100 ">
              PROFESSIONAL CERTIFICATION <br /> & PARTNERSHIPS
            </h1>
          </Col>
        </Row>)}

         {partnerData?.sort((a, b) => a.orderIndex - b.orderIndex)
  .map((category) => (
    <React.Fragment key={category.id}>
      {/* Category Title */}
      <Row className='justify-content-start mb-3'>
        <Col xs={12} lg={10} className='text-start p-0'>
          <p 
            className={`text-muted mb-3 ${!aboutPartner ? "mt-4" : ""}`}

            style={{ 
              fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
              fontWeight: '500' 
            }}
          >
            {category.name}:
          </p>
        </Col>
      </Row>

      {/* Partners Grid */}
      <Row 
        className="justify-content-start about-map"
        style={{ 
         
          borderLeft: `1px solid ${borderColor}`,
        }}
      >
        {category.partnerDetails
          .sort((a, b) => a.orderIndex - b.orderIndex)
          .map((partner) => (
            <Col
              key={partner.id}
              xs={6}
              sm={6}
              md={4}
              lg={3}
              className="d-flex justify-content-start px-2 px-md-3 align-items-center"
              style={{
                 borderTop: `1px solid ${borderColor}`, 
                borderRight: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
              }}
            >
              <img 
                src={imageBaseApi+partner.media.url} 
                alt={partner.name} 
                className="img-fluid" 
              />
            </Col>
          ))}
      </Row>
    </React.Fragment>
  ))}

       
      
        
      </Container>
    </div>
  )
}

export default Professional